// extracted by mini-css-extract-plugin
export var content = "ZoomRedirectModal-module--content--5d261";
export var icon = "ZoomRedirectModal-module--icon--cee05";
export var message = "ZoomRedirectModal-module--message--28708";